import './SCSS/main.scss';

import './js/functions.js';